/* lightzoom.js (Shopify-safe, multi-jQuery tolerant) */
(function attach(factory) {
  // Find *any* jQuery instance
  function getJQ() {
    if (typeof window.jQuery !== "undefined") return window.jQuery;
    if (typeof window.$ !== "undefined" && window.$ && window.$.fn && window.$.fn.jquery) return window.$;
    return null;
  }

  function tryInit() {
    var $ = getJQ();
    if (!$) return false;

    if ($.fn && $.fn.lightzoom) return true; // already attached

    factory($);

    // Remember which jQuery we used, so init code can call the same one
    if (typeof window.lightzoom$ === "undefined") {
      window.lightzoom$ = $;
    }
    return true;
  }

  if (!tryInit()) {
    // Poll briefly in case jQuery loads later (defer/footer)
    var until = Date.now() + 5000;
    var iv = setInterval(function () {
      if (tryInit() || Date.now() > until) { clearInterval(iv); }
    }, 50);
  }
})(function ($) {
  // Don't redefine
  if ($.fn.lightzoom) return;

  $.fn.lightzoom = function (options) {
    var settings = $.extend({ zoomPower: 1, glassSize: 250 }, options);
    var halfSize    = settings.glassSize / 2;
    var quarterSize = settings.glassSize / 4;
    var zoomPower   = settings.zoomPower;

    // Create lens + CSS once
    if (document.getElementById("glass") == null) {
      $("body").append('<div id="glass" aria-hidden="true"></div>');
      $('head').append(
        '<style id="lightzoom-style">#glass{position:absolute;width:'+settings.glassSize+'px;height:'+settings.glassSize+'px;pointer-events:none;z-index:9999;background:none;border:none;overflow:hidden;display:none;border-radius:50%;background-repeat:no-repeat;}</style>'
      );
    }

    function updateLens(event, imgEl) {
      var $glass = $("#glass");
      if (!imgEl || !imgEl.src) { $glass.hide(); return; }

      var rect = imgEl.getBoundingClientRect();
      var w = rect.width  || imgEl.naturalWidth  || 0;
      var h = rect.height || imgEl.naturalHeight || 0;
      if (!w || !h) { $glass.hide(); return; }

      var mx = (event.clientX + window.pageXOffset);
      var my = (event.clientY + window.pageYOffset);

      var $img = $(imgEl);
      var off  = $img.offset();
      var ol   = off.left;
      var ot   = off.top;

      if (mx > ol && mx < ol + w && my > ot && my < ot + h) {
        var offsetXfixer = ((mx - ol - w / 2) / (w / 2)) * quarterSize;
        var offsetYfixer = ((my - ot - h / 2) / (h / 2)) * quarterSize;

        var cx = (((mx - ol + offsetXfixer) / w)) * 100;
        var cy = (((my - ot + offsetYfixer) / h)) * 100;

        var top  = my - halfSize;
        var left = mx - halfSize;

        var minX = ol - halfSize;
        var minY = ot - halfSize;
        var maxX = ol + w - halfSize;
        var maxY = ot + h - halfSize;

        left = Math.min(Math.max(minX, left), maxX);
        top  = Math.min(Math.max(minY, top),  maxY);

        $glass.css({
          top: top,
          left: left,
          display: "block",
          backgroundImage: "url('" + imgEl.src + "')",
          backgroundSize:  (w * zoomPower) + "px " + (h * zoomPower) + "px",
          backgroundPosition: cx + "% " + cy + "%"
        });
      } else {
        $glass.hide();
      }
    }

    return this.each(function () {
      var imgEl = this;

      $(imgEl).on("mousemove.lightzoom", function (e) {
        updateLens(e, imgEl);
      });

      $(imgEl).on("mouseleave.lightzoom", function () {
        $("#glass").hide();
      });

      $(window).on("scroll.lightzoom", function () {
        $("#glass").hide();
      });
    });
  };
});